module.exports = __webpack_public_path__ + "assets/d05df06fd2b720c22a1adc17829b6e08.mp3";